import { Send, Users } from "lucide-react";
import { Language } from "../../../utils/dictionary";
import { INTEGRATIONS_UI_CONFIG } from "../config/integrations.config";
import type { ChannelWizardConfig } from "./ChannelIntegrationWizard";

const FLUXI_LOGO = "https://fluxi.s3.amazonaws.com/prod/assets/fluxi/fluxi-logo.svg";

export const messengerChannelConfig: ChannelWizardConfig = {
  channel: "messenger",
  title: {
    [Language.SPANISH]: "Conectar Messenger",
    [Language.ENGLISH]: "Connect Messenger",
    [Language.PORTUGUESE]: "Conectar Messenger",
  },
  description: {
    [Language.SPANISH]:
      "Conecta tu página de Facebook para recibir y responder mensajes de Messenger desde Fluxi.",
    [Language.ENGLISH]:
      "Connect your Facebook Page to receive and reply to Messenger messages from Fluxi.",
    [Language.PORTUGUESE]:
      "Conecte sua página do Facebook para receber e responder mensagens do Messenger pelo Fluxi.",
  },
  logoSrc: INTEGRATIONS_UI_CONFIG.messenger.logoSrc,
  fluxiLogoSrc: FLUXI_LOGO,
  accentColor: "#0084FF",
  connectButtonLabel: {
    [Language.SPANISH]: "Conectar con Facebook",
    [Language.ENGLISH]: "Connect with Facebook",
    [Language.PORTUGUESE]: "Conectar com Facebook",
  },
  permissions: [
    {
      id: "pages_messaging",
      label: {
        [Language.SPANISH]: "Enviar y recibir mensajes de la página",
        [Language.ENGLISH]: "Send and receive page messages",
        [Language.PORTUGUESE]: "Enviar e receber mensagens da página",
      },
    },
    {
      id: "pages_manage_metadata",
      label: {
        [Language.SPANISH]: "Gestionar webhooks y metadatos",
        [Language.ENGLISH]: "Manage webhooks and metadata",
        [Language.PORTUGUESE]: "Gerenciar webhooks e metadados",
      },
    },
  ],
  checklist: [
    {
      id: "facebook_page",
      label: {
        [Language.SPANISH]: "Tener una página de Facebook activa",
        [Language.ENGLISH]: "Have an active Facebook Page",
        [Language.PORTUGUESE]: "Ter uma página do Facebook ativa",
      },
    },
    {
      id: "page_admin",
      label: {
        [Language.SPANISH]: "Ser administrador de la página",
        [Language.ENGLISH]: "Be a Page admin",
        [Language.PORTUGUESE]: "Ser administrador da página",
      },
    },
  ],
  connectionSteps: [
    {
      id: "login",
      label: {
        [Language.SPANISH]: "Inicia sesión con Facebook",
        [Language.ENGLISH]: "Sign in with Facebook",
        [Language.PORTUGUESE]: "Entre com Facebook",
      },
    },
    {
      id: "select_page",
      label: {
        [Language.SPANISH]: "Selecciona la página a conectar",
        [Language.ENGLISH]: "Select the Page to connect",
        [Language.PORTUGUESE]: "Selecione a página para conectar",
      },
    },
    {
      id: "confirm",
      label: {
        [Language.SPANISH]: "Autoriza permisos de mensajería",
        [Language.ENGLISH]: "Authorize messaging permissions",
        [Language.PORTUGUESE]: "Autorize permissões de mensagens",
      },
    },
  ],
  features: [
    {
      icon: Send,
      label: {
        [Language.SPANISH]: "Respuestas manuales e IA en Messenger",
        [Language.ENGLISH]: "Manual and AI replies in Messenger",
        [Language.PORTUGUESE]: "Respostas manuais e IA no Messenger",
      },
    },
    {
      icon: Users,
      label: {
        [Language.SPANISH]: "Bandeja unificada con WhatsApp e Instagram",
        [Language.ENGLISH]: "Unified inbox with WhatsApp and Instagram",
        [Language.PORTUGUESE]: "Caixa unificada com WhatsApp e Instagram",
      },
    },
  ],
};
